/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Radio } from '../../../../../molecules/inputs/Radio/Radio';
import { Text } from '../../../../../atoms/Text/Text';
import './RadioFieldStyles.scss';
const baseClass = 'qmb-ui-radio-field';
export function RadioField({ name, label, options, value, onChange, disabled = false, error, required = false }) {
    const radioOptions = options.map((opt) => ({
        value: opt.value,
        label: opt.description ? (React.createElement("span", { className: `${baseClass}__option` },
            React.createElement(Text, { variant: "body" }, opt.label),
            React.createElement(Text, { variant: "xx-small", className: `${baseClass}__description` }, opt.description))) : (opt.label)
    }));
    return (React.createElement("div", { className: baseClass },
        React.createElement(Radio, { name: name, label: `${label}${required ? ' *' : ''}`, options: radioOptions, value: value, onChange: onChange, disabled: disabled, error: error })));
}
